import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  InputAdornment,
  IconButton,
  Button,
  Backdrop,
  CircularProgress,
} from "@mui/material";
// import Logo from "../../Assets/images/Logo.jpg";
import "./Login.css";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { loginUser } from "../../Apis/loginApis";
import { LoadingButton } from "@mui/lab";
import diningLogo from "../../Assets/images/logo1024.png";
import InstallPWA from "../../components/InstallPWA";
import useChangePassword from "../../hooks/customHooks/useChangePassword";
import ReusableDialog from "../../components/ReusableDialog";
import ForgotPasswordDialog from "../../components/ForgotPasswordDialog";

const Login = ({ setIsAuthenticated, setEmployeeInfo, setScanData }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const navigate = useNavigate();
  const { loading, isResetOpen, setIsResetOpen, handleChangePassword } =
    useChangePassword();

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const response = await loginUser(email.toLowerCase(), password);
      if (response.status) {
        // Set authentication state
        setIsAuthenticated(true);
        setEmployeeInfo({
          firstName: response.data.firstName,
          lastName: response.data.lastName,
          email: response.data.email,
          designation: response.data.designation,
        });
        setScanData([]); // Assuming scans are empty initially

        // Store response in local storage
        localStorage.setItem("user", JSON.stringify(response.data));

        // Navigate to the dashboard
        navigate("/mobile/dashboard");
      } else {
        setError("Login failed. Please check your credentials.");
      }
    } catch (err) {
      setError(err.message || "Login failed. Please try again.");
    }
    setIsLoading(false);
  };

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  const resendOtp = async () => {
    handleChangePassword(resetEmail);
    setError("");
  };

  return (
    <Box className="Login-main">
      <Box className="Login-nav">
        {/* <img src={Logo} alt="Logo" className="infojini-logo" /> */}
        <img src={diningLogo} alt="Logo" width={"100px"} />
      </Box>
      <Box display="flex" justifyContent="center" className="Login-form">
        <Box width="300px">
          <h1>Login</h1>
          <p>Welcome, Login to your account</p>
          <TextField
            fullWidth
            label="Work Email"
            margin="normal"
            value={email}
            placeholder="Enter your email"
            aria-label="Work Email"
            onChange={(e) => setEmail(e.target.value)}
            error={!!error}
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            fullWidth
            label="Password"
            type={showPassword ? "text" : "password"}
            margin="normal"
            value={password}
            placeholder="Enter your password"
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={!!error}
            helperText={error}
            InputLabelProps={{ shrink: true }}
          />
          <Button onClick={() => setIsOpen(true)}>Forgot Password ?</Button>
          <LoadingButton
            variant="contained"
            color="primary"
            fullWidth
            loading={isLoading}
            size="large"
            onClick={handleLogin}
            sx={{ marginTop: "15px" }}
          >
            Login
          </LoadingButton>
        </Box>
      </Box>
      <InstallPWA />
      <Backdrop open={loading} sx={{ color: "#fff", zIndex: 9999 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <ReusableDialog
        open={isResetOpen}
        onClose={() => setIsResetOpen(false)}
        title="otp"
        resendOtp={resendOtp}
        changePasswordPath={"forgot-password"}
      />
      <ForgotPasswordDialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        onSendOTP={handleChangePassword}
        setResetEmail={setResetEmail}
        resetEmail={resetEmail}
      />
    </Box>
  );
};

export default Login;
